<template lang="pug">
GreyPage
  FetchErrorTransition(
    :isFetching="isFetching"
    :error="fetchError"
    )
    BriqDataTable(
      :data="tableData"
      :allowDelete="false"
      :loading="isFetching"
      :initialSort="initialSort"
      :rowsAreClickable="false"
      data-test-id="invoices-data-table"
      style="width: 100%"
      v-if="canView"
      )
      template(v-slot:Date="{ item }")
        div(data-test-id="invoice-date") {{ getTime(item.Date) }}
      template(v-slot:PdfKey="{ item }")      
        BriqButton.download-button(
          variant="text"
          @click="download(item.Key, item.InvoiceId, 'pdf')"
          data-test-id="download-pdf"
          :disabled="isDownloading"
          )
          BriqIcon(name="icon-download_icon")
      template(v-slot:Key="{ item }")  
        BriqButton.download-button(
          variant="text"
          @click="download(item.Key, item.InvoiceId, 'specification')"
          data-test-id="download-csv"
          :disabled="isDownloading"
          )
          BriqIcon(name="icon-download_icon")
    div(v-else)
      h1(data-test-id="not-enough-permissions") Not enough permissions
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import BriqDataTable from '@v/components/BriqDataTable.vue'
import { fromUtc } from '@/helpers/dateTimeFormatter.js'

export default {
  name: 'InvoicesWrapper',
  data() {
    return {
      initialSort: {
        sort: 'asc',
        sortField: 'Date',
      },
      userViewPermission: 'API_Admin_Billing_View_Invoices',
    }
  },
  components: { BriqDataTable },
  computed: {
    ...mapState('businessUnitBillingData', [
      'fetchError',
      'saveError',
      'downloadError',
      'invoices',
    ]),
    ...mapGetters('businessUnitBillingData', ['isFetching', 'isDownloading']),
    ...mapGetters('briqState', ['userHasPermission']),
    canView() {
      return this.userHasPermission(this.userViewPermission)
    },
    tableData() {
      return {
        items: this.invoices || [],
        headers: [
          { field: 'Status', label: 'Status' },
          { field: 'Date', label: 'Invoice Date' },
          { field: 'PdfKey', label: 'PDF' },
          { field: 'Key', label: 'Specification' },
        ],
      }
    },
  },
  methods: {
    ...mapActions('businessUnitBillingData', ['fetchInvoices', 'dowloadInvoice']),
    async download(invoiceKey, invoiceId, type = 'pdf') {
      const response = await this.dowloadInvoice({ invoiceKey, type })
      if (response.success) {
        const contentType = type === 'pdf' ? 'application/pdf' : 'text/csv'
        const blob = new Blob([response.data], { type: contentType })
        const link = this.$document.createElement('a')
        link.href = this.$window.URL.createObjectURL(blob)
        const extension = type === 'specification' ? 'csv' : 'pdf'
        link.download = `${invoiceId}.${extension}`
        link.click()
        this.$notifySuccess(response.message)
      } else {
        if (this.downloadError.parsedError) {
          const { FriendlyDescription, TechnicalDescription } = {
            ...this.downloadError.parsedError.data,
          }
          this.$handleError({
            error: this.downloadError.rawError,
            notification: FriendlyDescription || response.message,
          })
          if (TechnicalDescription) this.$logError(TechnicalDescription)
        } else {
          this.$notifyError(this.downloadError.message)
        }
      }
    },
    getTime(dateTimeUtc) {
      return fromUtc()(this.$locale)(this.$timezone)(dateTimeUtc)
    },
  },
  async beforeMount() {
    await this.fetchInvoices()
  },
}
</script>
